import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, GraduationCap, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function IHSetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("La contraseña debe tener al menos 8 caracteres."); return; }
    if (password !== confirm) { toast.error("Las contraseñas no coinciden."); return; }
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/auth/ih-set-password`, { token, password });
      setDone(true);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-secondary/40 flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white rounded-2xl border border-border p-8 fade-in">
        <div className="flex items-center gap-2 mb-6">
          <GraduationCap className="w-7 h-7 text-accent" />
          <h1 className="text-xl font-bold text-primary">Crear mi contraseña</h1>
        </div>
        {done ? (
          <div className="text-center space-y-4" data-testid="ih-setpw-done">
            <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" />
            <p className="text-sm text-slate-600">Tu contraseña quedó creada. Ya puedes ingresar al portal.</p>
            <Button className="w-full h-12 rounded-xl" onClick={() => navigate("/portal-ih")} data-testid="ih-setpw-goportal">Ir al portal</Button>
          </div>
        ) : !token ? (
          <p className="text-sm text-destructive" data-testid="ih-setpw-notoken">El enlace no es válido. Solicita uno nuevo desde el portal.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-muted-foreground">Por tu seguridad, crea una contraseña personal (mínimo 8 caracteres). Podrás cambiarla cuando quieras desde tu portal.</p>
            <div>
              <Label className="text-sm font-semibold text-slate-600">Nueva contraseña</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl mt-1.5" required data-testid="ih-setpw-password" />
            </div>
            <div>
              <Label className="text-sm font-semibold text-slate-600">Repite la contraseña</Label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-12 rounded-xl mt-1.5" required data-testid="ih-setpw-confirm" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl" data-testid="ih-setpw-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Crear contraseña"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
